import * as React from "react";

import { ObservableValue } from "azure-devops-ui/Core/Observable";

import { Button } from "azure-devops-ui/Button";
import { Location } from "azure-devops-ui/Utilities/Position";
import { Observer } from "azure-devops-ui/Observer";
import { TeachingBubble } from "azure-devops-ui/TeachingBubble";

export default class TeachingBubbleExample extends React.Component {
    private showBubble = new ObservableValue<boolean>(false);
    private teachingBubbleRoot: HTMLDivElement;
    private newPipelineButtonRef = React.createRef<Button>();

    public render() {
        return (
            <div style={{ margin: "8px" }}>
                <div ref={this.callbackRef}>
                    <Button ref={this.newPipelineButtonRef} text="New Pipeline" />
                </div>
                <Observer showBubble={this.showBubble}>
                    {(props: { showBubble: boolean }) => {
                        return props.showBubble ? (
                            <TeachingBubble
                                anchorElement={this.teachingBubbleRoot}
                                anchorOrigin={{
                                    horizontal: Location.start,
                                    vertical: Location.end
                                }}
                                imageProps={{
                                    alt: "Azure Pipelines Logo - a large blue rocket",
                                    containImage: true,
                                    src: require("./Azure-Pipelines.png")
                                }}
                                onDismiss={this.teachingBubbleDismissHandler}
                                primaryButtonProps={{
                                    text: "Learn more",
                                    target: "_blank",
                                    href:
                                        "https://dev.azure.com/mseng/AzureDevOps/_wiki/wikis/AzureDevOps.wiki?wikiVersion=GBwikiMaster&pagePath=%2FRead%20this%20first&pageId=2384"
                                }}
                                secondaryButtonProps={{
                                    text: "Next",
                                    onClick: () => {
                                        alert("next");
                                    }
                                }}
                                title="Pipelines"
                                text="Clicking on the button will allow you to create a new Pipeline"
                            />
                        ) : null;
                    }}
                </Observer>
            </div>
        );
    }

    private callbackRef = (element: HTMLDivElement) => {
        this.teachingBubbleRoot = element;
        this.showBubble.value = true;
    };

    private teachingBubbleDismissHandler = () => {
        this.showBubble.value = false;
        this.newPipelineButtonRef.current?.focus();
    }
}
